<!--
/*
Important
This file is used only for the vue3 application.
Changes made here will not be reflected in the Vue2 application.
You need to make changes in the vue2 file also
Vue3 file: Velocity.PrimaryOffersites.Web\wwwroot\js\components\shared\DirectionSelection\DirectionSelection.vue
Any clarifications contact Leela Directly
*/

-->

<template>
  <div>
    <Modal id="textmodal" hide-header hide-footer centered @hideModal="oncloseclick">
      <div v-for="dealerDetails in availableDealerDetailsForPrimarySites" :key="dealerDetails.id">
        <div class="mt-4 mb-4">
          <h5 class="text-center font-weight-bold text-uppercase color-black">
            <span v-html="dealerDetails.deptName" />
          </h5>
          <a
            class="bgcolor-primary text-white no-hover rounded-buttons theme-bg-color Phone_Sales"
            @click.prevent="onDirectionsSelectionClick(dealerDetails.dealerAddress)"
            >{{ dealerDetails.dealerAddress }}</a
          >
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "../Shared/Modal/Modal.vue";
import ShiftDigitalContainer from "../../Events/ShiftDigital/ShiftDigitalContainer";
import { SHIFT_DIGITAL_GET_DIRECTIONS_EVENT } from "@/js/services/ShiftDigital/ShiftDigitalConstants";
import { MapService } from "../../Services/MapService/MapService";
import { Events } from "../../Events/ConsumerEvents/Events";

export default {
  components: {
    Modal,
  },
  props: {
    availableDealerDetailsForPrimarySites: {
      type: Array,
      default() {
        return [];
      },
    },
    availableDepartmentsForDealer: {
      type: Array,
      default() {
        return [];
      },
    },
    availableAddressForDealer: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      shiftDigital: "",
      modalShow: true,
      headerBackGroundColor: "",
      headerFontColor: "",
    };
  },

  mounted() {
    this.shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
  },

  methods: {
    oncloseclick() {
      this.$emit("hidemodal");
    },
    onDirectionsSelectionClick(Address) {
      //* open native maps app in mobile
      window.location.href = MapService.openMapsAppInMobile(Address);
      this.$emit("hidemodal");
      let eventModel = {
        ...Events.consumerEventModel,
        consumerEventId: Events.eventsConstants.opengetdirectionForm,
      };
      Events.logConsumerEvent(eventModel);
      logGoogleBingEvent("Header", "GetDirection", "Get Directions", 1, "Get Directions");
      if (this.shiftDigital) {
        this.shiftDigital.submitEvent(SHIFT_DIGITAL_GET_DIRECTIONS_EVENT);
      }
    },
  },
};
</script>

<style scoped>
a {
  display: inline-block;
  width: 100%;

  padding: 10px;
  text-align: center;
}
</style>
